/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var Spec = {
    'MOL_ID': '',
    'MOLECULE': '',
    'CHAIN': '',
    'FRAGMENT': '',
    'SYNONYM': '',
    'EC': '',
    'ENGINEERED': '',
    'MUTATION': '',
    'OTHER_DETAILS': ''
};
export function parseCmpnd(lines, lineStart, lineEnd) {
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    var currentSpec;
    var currentCompound = { chains: [], description: '' };
    var Compounds = [];
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS       DATA TYPE       FIELD         DEFINITION
        // ----------------------------------------------------------------------------------
        //  1 -  6       Record name     "COMPND"
        //  8 - 10       Continuation    continuation  Allows concatenation of multiple records.
        // 11 - 80       Specification   compound      Description of the molecular components.
        //               list
        var cmpnd = line.substr(10, 70).trim();
        var cmpndSpecEnd = cmpnd.indexOf(':');
        var cmpndSpec = cmpnd.substring(0, cmpndSpecEnd);
        var value = void 0;
        if (cmpndSpec in Spec) {
            currentSpec = cmpndSpec;
            value = cmpnd.substring(cmpndSpecEnd + 2);
        }
        else {
            value = cmpnd;
        }
        value = value.replace(/;$/, '');
        if (currentSpec === 'MOL_ID') {
            currentCompound = {
                chains: [],
                description: ''
            };
            Compounds.push(currentCompound);
        }
        else if (currentSpec === 'MOLECULE') {
            if (currentCompound.description)
                currentCompound.description += ' ';
            currentCompound.description += value;
        }
        else if (currentSpec === 'CHAIN') {
            Array.prototype.push.apply(currentCompound.chains, value.split(/\s*,\s*/));
        }
    }
    return Compounds;
}
export function parseHetnam(lines, lineStart, lineEnd) {
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    var hetnams = new Map();
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS       DATA  TYPE    FIELD           DEFINITION
        // ----------------------------------------------------------------------------
        //  1 -  6       Record name   "HETNAM"
        //  9 - 10       Continuation  continuation    Allows concatenation of multiple records.
        // 12 - 14       LString(3)    hetID           Het identifier, right-justified.
        // 16 - 70       String        text            Chemical name.
        var het = line.substr(11, 3).trim();
        var name_1 = line.substr(15).trim();
        if (hetnams.has(het)) {
            hetnams.set(het, hetnams.get(het) + " " + name_1);
        }
        else {
            hetnams.set(het, name_1);
        }
    }
    return hetnams;
}
//# sourceMappingURL=entity.js.map